


const hours = getSupportHoursForToday();
if (!hours) {
 $('.superContact li.tel').addClass('closed');

}

else if (isSupportOnline(hours)) {
    
}
else {
    $('.superContact li.tel').addClass('closed');
}


function fixedHolidays(year) {
    return [
        `${year}-01-01`,
        `${year}-05-01`,
        `${year}-05-08`,
        `${year}-07-05`,
        `${year}-07-06`,
        `${year}-09-28`,
        `${year}-10-28`,
        `${year}-11-17`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
    ];
}

function getEasterDates(year) {
    let f = Math.floor,
        a = year % 19,
        b = f(year / 100),
        c = year % 100,
        d = f(b / 4),
        e = b % 4,
        g = f((8 * b + 13) / 25),
        h = (19 * a + b - d - g + 15) % 30,
        i = f(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = f((a + 11 * h + 22 * l) / 451),
        month = f((h + l - 7 * m + 114) / 31),
        day = ((h + l - 7 * m + 114) % 31) + 1;
    const sunday = new Date(year, month - 1, day);
    const monday = new Date(year, month - 1, day + 1);
    return [
        sunday.toISOString().slice(0, 10),
        monday.toISOString().slice(0, 10),
    ];
}

function toMinutes(time) {
    if (!time) return null;
    const [h, m] = time.split(':');
    return parseInt(h) * 60 + parseInt(m);
}

function getSupportHoursForToday() {
    const now = new Date();
    const year = now.getFullYear();
    const today = now.toISOString().slice(0, 10);
    const weekday = now.getDay() === 0 ? 7 : now.getDay();
    if (manualExtendedHours[today]) {
        return manualExtendedHours[today];
    }
    if (manualClosedDays[today]) {
        return null;
    }
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
    if (holidays.includes(today)) {
        return null;
    }
    return supportHours[weekday] || null;
}

function isSupportOnline(hours) {
    if (!hours) return false;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const open = toMinutes(hours.open);
    const close = toMinutes(hours.close);

    return currentMinutes >= open && currentMinutes < close;
}


function isHoliday(date) {
    const year = date.getFullYear();
    const iso = date.toISOString().slice(0, 10);
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
    return holidays.includes(iso);
}

function isWorkingDay(date) {
    const day = date.getDay(); // 0 = ne
    return day !== 0 && day !== 6 && !isHoliday(date);
}

function afterDeliveryCutoff(now) {
    const [h, m] = deliveryHours.split(':').map(Number);
    return now.getHours() * 60 + now.getMinutes() >= (h * 60 + m);
}

function addWorkingHours(startDate, hoursToAdd) {
    const date = new Date(startDate);
    let remaining = hoursToAdd;

    while (remaining > 0) {
        date.setHours(date.getHours() + 1);

        if (isWorkingDay(date)) {
            remaining--;
        }
    }

    return date;
}

function formatDispatchDate(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const target = new Date(date);
    target.setHours(0, 0, 0, 0);

    const diffDays = Math.round((target - today) / (1000 * 60 * 60 * 24));

    const day = date.getDate();
    const month = date.getMonth() + 1;

    if (diffDays === 0) return `odešleme dnes`;
    if (diffDays === 1) return `odešleme zítra ${day}. ${month}.`;
    if (diffDays === 2) return `odešleme pozítří ${day}. ${month}.`;

    return `odešleme ${day}. ${month}`;
}



/**
 * Vypočítá datum odeslání podle dostupnosti (dispatch date).
 * Pokud je dostupnost "skladem" a už je po limitu, posune na další pracovní den.
 * Pro ostatní stavy vrací null.
 */
function getDispatchDateByAvailability(availabilityText) {
    if (availabilityText !== 'skladem, ihned k odeslání') return null;

    const now = new Date();
    const [h, m] = deliveryHours.split(':').map(Number);
    const cutoffMinutes = h * 60 + m;
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const dispatch = new Date(now);

    if (currentMinutes >= cutoffMinutes) {
        // přesun na první následující pracovní den
        do {
            dispatch.setDate(dispatch.getDate() + 1);
        } while (!isWorkingDay(dispatch));
    }

    // nastavíme čas na začátek pracovní doby (9:00)
    dispatch.setHours(9, 0, 0, 0);

    return dispatch;
}